/**
 * True when the lore current-user payload belongs to a staff member.
 * Mirrors the existing `currentUser.data.isStaff` checks in Navigation/Account.
 *
 * @param {{ data?: { isStaff?: boolean } } | null | undefined} currentUser
 * @returns {boolean}
 */
export default function isStaffUser(currentUser) {
  return Boolean(currentUser && currentUser.data && currentUser.data.isStaff);
}
